import { render, staticRenderFns } from "./IristarFoot.vue?vue&type=template&id=627bfec7&"
import script from "./IristarFoot.vue?vue&type=script&lang=js&"
export * from "./IristarFoot.vue?vue&type=script&lang=js&"
import style0 from "./IristarFoot.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports